<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
<datalist id="zip-codes">
  @for (address of zipCodeList; track address) {
    <option (click)="selectZipCode(address)" [value]="address.zipcode">
    {{address.zipcode}}, {{address.city}}</option>
  }
</datalist>
<!-- ============================================================== -->
<!-- Start Page Content here -->
<!-- ============================================================== -->
<div class="content-page bg-gray text-dark">
  <div class="content p-1">
    <div class="d-flex align-items-center m-0 p-1">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb m-0 p-0">
          <li class="breadcrumb-item"><a [routerLink]="['/service']">Service</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{ words[language][ 'detail' ] }}
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Ticket #: {{ticketId ? ticketId : 'NEW'}}
          </li>
        </ol>
      </nav>
      <ul class="list-group list-group-horizontal ml-auto">
        <li class="list-group-item"><a href="javascript:;" class="mx-1">Print Agreement</a></li>
        <li class="list-group-item"><a href="javascript:;" class="mx-1">Take a Payment</a></li>
        <li class="list-group-item"><a href="javascript:;" class="mx-1">View Payment Schedule</a></li>
        <li class="list-group-item"><a href="javascript:;" class="mx-1 link-danger"
        data-target="#deleteHeaderModal" data-toggle="modal">Delete Ticket</a></li>
      </ul>
    </div>

    @if (ticketId > 0) {
      <section class="sticky-toolbar rounded">
        <div class="card">
          <div title="Show Alerts & Notes">
            <notes [module]="'service'" [serviceId]="ticketId" title="Show Alerts & Notes"></notes>
          </div>
        </div>
      </section>
    }

    <div class="row">
      <div class="col-md-4">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a href="#general" data-toggle="tab" aria-expanded="false" class="nav-link active">
              <span class="mdi mdi-home-variant d-md-none d-block"></span>
              <span class="d-none d-md-block">General</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="#customer" data-toggle="tab" aria-expanded="false" class="nav-link">
              <span class="mdi mdi-home-variant d-md-none d-block"></span>
              <span class="d-none d-md-block">Customer</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="#vehicle" data-toggle="tab" aria-expanded="true" class="nav-link">
              <span class="mdi mdi-account-circle d-md-none d-block"></span>
              <span class="d-none d-md-block">Vehicle</span>
            </a>
          </li>
          <li class="nav-item">
            <a href="#costSummary" data-toggle="tab" aria-expanded="false" class="nav-link">
              <span class="mdi mdi-settings-outline d-md-none d-block"></span>
              <span class="d-none d-md-block">Cost Summary</span>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane show active" id="general">
            <div class="card border">
              <div class="card-body">
                <div class="card-text">
                  <form [formGroup]="headerInformation">
                    <div class="row d-flex">
                      <div class="form-group col-md-12 col-sm-12">
                        <label>Service Date</label>
                        <input class="form-control form-control-sm" (blur)="changed()"
                          formControlName="serviceDate" name="serviceDate"
                          type="datetime-local">
                      </div>
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Status</label>
                        <select class="custom-select custom-select-sm" (blur)="changed()"
                          formControlName="status">
                          <option>Open</option>
                          <option>Closed</option>
                          <option>Cancelled</option>
                          <option>On Hold</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Promised Date</label>
                        <input class="form-control form-control-sm" type="date"
                          (blur)="changed()" formControlName="promisedDate">
                      </div>
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Servicer</label>
                        <select class="custom-select custom-select-sm">
                          <option>Rahma, Masar</option>
                          <option>Albarazanchi, Shahad</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Vehicle Location</label>
                        <select class="custom-select custom-select-sm">
                          <option>Acme Motors</option>
                          <option>Fast Lane Auto</option>
                        </select>
                      </div>
                      <div class="form-group col-md-12 col-sm-12">
                        <label>Description of Service</label>
                        <textarea class="form-control form-control-sm" rows="2"
                        (blur)="changed()" formControlName="description"></textarea>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              @if (saleInfo) {
                <div class="card-footer d-flex justify-content-between">
                  <span><a [routerLink]="['/sales' + saleInfo.saleId]">Go to Sale</a></span>
                </div>
              }
            </div>
          </div>
          <div class="tab-pane" id="customer">
            <div class="card border">
              <div class="card-body tableFixHead">
                @if (saleContactsListOptions) {
                  <div>
                    <h3>Select Contact from list below</h3>
                    <div class="list-group">
                      @for (option of saleContactsListOptions; track option) {
                        <a href="javascript:;" (click)="setContact(option)"
                          class="list-group-item list-group-item-action"
                          >
                          <div class="d-flex w-100 justify-content-between">
                            <h5 class="mb-1">{{option.contactName}}</h5>
                            <small>Sale Date: {{option.saleDate | date:
                            'shortDate'}}</small>
                          </div>
                          <p class="mb-1">Stock Number: {{option.stockNumber}}</p>
                        </a>
                      }
                    </div>
                  </div>
                }
                @if (!saleContactsListOptions && !headerInformation.get('contactId').value || ticketId == 0 && show) {
                  <form [formGroup]="form"
                    >
                    <label class="text-nowrap">Search for Contact</label>
                    <contact-advanced-search [type]="'salesLead'" [displayLabel]="false"
                    (setContactId)="selectContact($event)"></contact-advanced-search>
                  </form>
                }
                <form [formGroup]="headerInformation">
                  <div class="row">
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="contactFirstName">First Name</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="contactFirstName" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="contactLastName">Last Name</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="contactLastName" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-12 col-sm-12">
                      <label for="contactCompanyName">Company Name</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="contactCompanyName" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="cellPhone">Cell</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="cellPhone" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="workPhone">Work</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="workPhone" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="homePhone">Home</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="homePhone" (blur)="changed()">
                    </div>
                    <div class="form-group col-md-6 col-sm-12">
                      <label for="emailAddress">Email Address</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="emailAddress" (blur)="changed()">
                    </div>
                    <div class="mb-0 col-md-12 d-flex justify-content-center align-items-center">
                      <label class="pb-0">Preferred Method</label>
                      <div class="form-check form-check-inline ml-auto">
                        <input type="radio" id="customRadio3" name="preferredContactMethod"
                          formControlName="preferredContactMethod" value="Call"
                          (blur)="changed()" class="form-check-input">
                        <label class="form-check-label" for="customRadio3">Call</label>
                      </div>
                      <div class="form-check form-check-inline ml-auto">
                        <input type="radio" id="customRadio3" name="preferredContactMethod"
                          formControlName="preferredContactMethod" value="Email"
                          (blur)="changed()" class="form-check-input">
                        <label class="form-check-label" for="customRadio3">Email</label>
                      </div>
                      <div class="form-check form-check-inline ml-auto">
                        <input type="radio" id="customRadio4" name="preferredContactMethod"
                          formControlName="preferredContactMethod" value="Text"
                          (blur)="changed()" class="form-check-input">
                        <label class="form-check-label" for="customRadio4">Text</label>
                      </div>
                    </div>
                    <div class="mb-0 col-md-12">
                      <label for="address">Address</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="address" (blur)="changed()">
                    </div>
                    <div class="mb-0 col-md-6">
                      <label for="address2">Address 2</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="address2" (blur)="changed()">
                    </div>
                    <div class="mb-0 col-md-6">
                      <label for="zipCode">Zip Code</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="zipCode" (blur)="changed()" (keyup)="searchZipCode()"
                        list="zip-codes">
                    </div>
                    <div class="mb-0 col-md-6">
                      <label for="city">City</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="city" (blur)="changed()">
                    </div>
                    <div class="mb-0 col-md-6">
                      <label for="state">State</label>
                      <input class="form-control form-control-sm" type="text"
                        formControlName="state" (blur)="changed()">
                    </div>
                  </div>
                </form>
              <!-- </div> -->
            </div>
            <div class="card-footer">
              <div class="d-flex justify-content-between">
                @if (headerInformation.get('contactFirstName').value || headerInformation.get('contactLastName').value || headerInformation.get('contactCompanyName').value) {
                  <span class="float-right text-primary"
                    (click)="resetHeaderInformation('contact')"><span class="uil-redo"></span> Clear
                  </span>
                }
                @if (saleInfo) {
                  <span><a [routerLink]="['/sales' + saleInfo.saleId]">Go to
                  Sale</a></span>
                }
                @if (saleInfo && saleInfo.buyerName) {
                  <span>Sale Buyer:
                  {{saleInfo.buyerName}}</span>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="vehicle">
          <div class="card border">
            <div class="card-body">
              <form [formGroup]="headerInformation">
                <div class="row">
                  <div class="form-group col-md-12 col-sm-12">
                    @if (vehicleListOptions) {
                      <h3>Select VIN from list below</h3>
                    }
                    @if (vehicleListOptions) {
                      <div class="list-group">
                        @for (option of vehicleListOptions; track option) {
                          <a href="javascript:;" (click)="selectVehicle(option)"
                            class="list-group-item list-group-item-action"
                            >
                            <div class="d-flex w-100 justify-content-between">
                              <h5 class="mb-1">{{option.vehicleInfo.vinNumber}}</h5>
                              <small>Sale Date: {{option.saleDate | date:
                              'shortDate'}}</small>
                            </div>
                            <p class="mb-1">Stock Number: {{option.stockNumber}}</p>
                          </a>
                        }
                        or enter a new VIN
                      </div>
                    }
                    @if (!headerInformation.get('vehicleId').value) {
                      <div>
                        <label for="vinNumber">VIN</label>
                        <div class="input-group">
                          <input class="form-control form-control-sm text-dark" type="text"
                            id="vinNumber" [(ngModel)]="vinNumber"
                            (ngModelChange)="vinNumber = $event.toUpperCase()"
                            [ngModelOptions]="{standalone: true}" autocomplete="off"
                            (blur)="setVehicle()">
                          @if (vinNumber === null) {
                            <button class="btn btn-info btn-sm float-right"
                              data-target="#scanVIN"
                              data-toggle="modal"
                            id="btn-save-generalInformation">Scan</button>
                          }
                        </div>
                        @if (message && vehicleInfo) {
                          <small class="text-danger">{{message}}<a
                            [routerLink]="['/inventory/' + vehicleInfo.inventoryId]">go to
                          Inventory</a></small>
                        }
                      </div>
                    }
                    @if (headerInformation.get('vehicleId').value) {
                      <div>
                        {{vinNumber}}
                      </div>
                    }
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="vehicleExteriorColor">Exterior Color</label>
                    <input class="form-control form-control-sm" type="text" (blur)="changed()"
                      formControlName="vehicleExteriorColor">
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="mileage">Mileage</label>
                    <input class="form-control form-control-sm" type="text" (blur)="changed()"
                      formControlName="mileage">
                  </div>
                  <div class="form-group col-md-6 col-sm-12">
                    <label for="licensePlateNumber">Plate Number</label>
                    <input class="form-control form-control-sm" type="text" (blur)="changed()"
                      formControlName="licensePlateNumber">
                  </div>
                  @if (vehicleInfo) {
                    <div>
                      <p class="mb-0 col-md-12">{{vehicleInfo.make}}
                        {{vehicleInfo.model}} {{vehicleInfo.modelYear}} {{vehicleInfo.engine}}
                      {{vehicleInfo.bodyStyle}}</p>
                    </div>
                  }
                </div>
              </form>
            </div>
            <div class="card-footer">
              @if (headerInformation.get('vehicleId').value || message) {
                <span class="float-right text-primary"
                  (click)="resetHeaderInformation('vehicle')"><span class="uil-redo"></span>Clear</span>
                }
                @if (saleInfo && saleInfo.saleId) {
                  <div class="row d-flex justify-content-between">
                    <span><a [routerLink]="['/sales' + saleInfo.saleId]">Go to Sale</a></span>
                  </div>
                }
                @if (vehicleInfo && vehicleInfo.inventoryId) {
                  <div class="row d-flex justify-content-between"
                    >
                    <span><a [routerLink]="['/inventory/' + vehicleInfo.inventoryId]">Go to
                    Inventory</a></span>
                    @if (vehicleInfo.stockNumber) {
                      <span>Stock #: {{vehicleInfo.stockNumber}}</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="tab-pane" id="costSummary">
            <div class="card border">
              <div class="card-body pb-0">
                @if (totals) {
                  <ul id="snapshot-items">
                    @for (total of totals.groupTotals; track total) {
                      <li>
                        <p>{{total.serviceType}}</p>
                        <p class="text-right">${{total.total_amount || 0 | number: '1.2-2' }}</p>
                      </li>
                    }
                    <li>
                      <p>Hazardous Materials</p>
                      <p class="text-right">$0.00</p>
                    </li>
                    <hr />
                    <li>
                      <p>Labor Taxes</p>
                      <p class="text-right">${{totals.laborTaxes || 0 | number: '1.2-2' }}</p>
                    </li>
                    <li>
                      <p>Part Taxes</p>
                      <p class="text-right">${{totals.partsTaxes || 0 | number: '1.2-2' }}</p>
                    </li>
                    <li class="total">
                      <p>TOTAL</p>
                      <p class="text-right">${{totals.total || 0 | number: '1.2-2' }}</p>
                    </li>
                  </ul>
                }

                @if (this.totals['total'] > 0) {
                  <form [formGroup]="terms">
                    <div class="row">
                      <div class="h4">Payment Plan</div>
                      <div class="form-group col-md-12 col-sm-12">
                        <div class="form-check form-check-inline">
                          <input type="radio" id="oneTimePayment" name="paymentPlan"
                            formControlName="paymentPlan" class="form-check-input"
                            value="single" (change)="calculate($event)">
                          <label class="form-check-label" for="oneTimePayment">One-Time
                          Payment</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input type="radio" id="paymentPlan" name="paymentPlan"
                            value="multiple" formControlName="paymentPlan"
                            class="form-check-input" (change)="calculate($event)">
                          <label class="form-check-label" for="paymentPlan">Multiple
                          Payments</label>
                        </div>
                      </div>
                    </div>
                    @if (terms.get('paymentPlan').value == 'multiple') {
                      <div class="row">
                        <div class="form-group col-md-6 col-sm-12">
                          <label for="firstScheduledPmtDateDue">1st Payment Due</label>
                          <input class="form-control form-control-sm text-dark" type="date"
                            id="firstScheduledPmtDateDue" formControlName="firstScheduledPmtDateDue"
                            autocomplete="off">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                          <label for="paymentCycle">Payment Cycle</label>
                          <select id="paymentCycle" formControlName="paymentCycle" name="paymentCycle"
                            class="form-control form-control-sm text-dark"
                            (change)="calculate($event)">
                            @for (paymentCycle of paymentCycles; track paymentCycle) {
                              <option [value]="paymentCycle"
                                >
                              {{paymentCycle}}</option>
                            }
                          </select>
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                          <label for="numberOfPmts">Number of Payments</label>
                          <input class="form-control form-control-sm text-dark" type="number"
                            id="numberOfPmts" formControlName="numberOfPmts" autocomplete="off"
                            name="numberOfPmts" (blur)="calculate($event)">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                          <label for="paymentAmount">Payment Amount</label>
                          <input class="form-control form-control-sm text-dark" type="number"
                            id="paymentAmount" formControlName="paymentAmount" autocomplete="off"
                            name="paymentAmount" (blur)="calculate($event)">
                        </div>
                        <div class="form-group col-md-6 col-sm-12">
                          <label for="finalOddLastPayment">Final Odd Last Amount</label>
                          <input class="form-control form-control-sm text-dark" type="number"
                            id="finalOddLastPayment" formControlName="finalOddLastPayment"
                            autocomplete="off" name="finalOddLastPayment"
                            (blur)="calculate($event)">
                        </div>
                        <!-- <div class="form-group col-md-6 col-sm-12">
                        <label for="APR">APR</label>
                        <input class="form-control form-control-sm text-dark" type="number" id="APR"
                          formControlName="APR" autocomplete="off" name="APR"
                          (blur)="calculate($event)">
                      </div> -->
                    </div>
                  }
                  <button class="btn btn-light">Calculate</button>
                </form>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <div class="card border">
        <div class="card-header">
          Service Lines
          <div class="dropdown float-right">
            <button type="button" class="btn btn-primary btn-sm dropdown-toggle" id="addServiceLineMenu"
              data-toggle="dropdown" aria-expanded="false"
              [disabled]="!headerInformation.get('vehicleId').value">
              <span class="dripicons dripicons-plus"></span>
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="add('Parts')">Add Part</a>
              <a class="dropdown-item default" (click)="add('Labor')">Add Labor</a>
            </div>
          </div>
        </div>
        <div class="card-body">
          @if (lineInfoCreate) {
            <form [formGroup]="lineInformation" id="lineInfoNew">
              <div class="row">
                <div class="form-group col-md-3 col-sm-12">
                  <label for="serviceType">Type</label>
                  <select class="custom-select custom-select-sm" formControlName="serviceType">
                    <option>Labor</option>
                    <option>Parts</option>
                  </select>
                </div>
                <div class="form-group col-md-6 col-sm-12">
                  <label for="description">Description</label>
                  <textarea class="form-control form-control-sm" type="text"
                  formControlName="description"></textarea>
                </div>
                @if (lineInformation.get('serviceType').value == 'Parts') {
                  <div class="form-group col-md-3 col-sm-12"
                    >
                    <label for="partNumber">Part Number</label>
                    <input class="form-control form-control-sm" type="text"
                      formControlName="partNumber">
                  </div>
                }
                @if (lineInformation.get('serviceType').value == 'Parts') {
                  <div class="form-group col-md-3 col-sm-12"
                    >
                    <label for="quantity">Quantity</label>
                    <input class="form-control form-control-sm" type="number"
                      formControlName="quantity">
                  </div>
                }
                @if (lineInformation.get('serviceType').value == 'Parts') {
                  <div class="form-group col-md-3 col-sm-12"
                    >
                    <label for="price">Price</label>
                    <input class="form-control form-control-sm" type="number" formControlName="price">
                  </div>
                }
                @if (lineInformation.get('serviceType').value == 'Labor') {
                  <div class="form-group col-md-3 col-sm-12"
                    >
                    <label for="rate">Rate</label>
                    <input class="form-control form-control-sm" type="number" formControlName="rate">
                  </div>
                }
                @if (lineInformation.get('serviceType').value == 'Labor') {
                  <div class="form-group col-md-3 col-sm-12"
                    >
                    <label for="hours">Hours</label>
                    <input class="form-control form-control-sm" type="number" formControlName="hours">
                  </div>
                }
              </div>
              <label for="lineTotal">Line Total</label>
              ${{calculateLineTotal() | number: '1.2-2'}}
              <div class="float-right d-flex justify-content-between">
                <button type="button" class="btn btn-danger btn-sm" id="cancel"
                  (click)="resetNewLineInformation()">
                  Cancel
                </button>
                <button type="button" class="btn btn-primary btn-sm" id="save" (click)="save(0)"
                  [disabled]="this.lineInformation.pristine">
                  <span class="dripicons dripicons-cloud-upload"></span>
                  Save
                </button>
              </div>
            </form>
          }
          <div class="tableFixHead">
            @if (lines ? lines.length > 0 : false) {
              <table class="table table-sm">
                <thead class="text-dark text-nowrap">
                  <tr>
                    <th>Type</th>
                    <th class="w-25">Description</th>
                    <th class="text-nowrap">Part #</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Rate</th>
                    <th>Hours</th>
                    <th>Line Total</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (line of lines; track line; let i = $index) {
                    <tr>
                      <td colspan="6" id="lineInfoEdit-{{i}}" class="d-none">
                        <form [formGroup]="lineInformation">
                          <div class="row">
                            <div class="form-group col-md-3 col-sm-12">
                              <label for="serviceType">Type</label>
                              <select class="custom-select custom-select-sm"
                                formControlName="serviceType">
                                <option>Labor</option>
                                <option>Parts</option>
                              </select>
                            </div>
                            <div class="form-group col-md-6 col-sm-12">
                              <label for="description">Description</label>
                              <textarea class="form-control form-control-sm" type="text"
                              formControlName="description"></textarea>
                            </div>
                            <div class="form-group col-md-3 col-sm-12">
                              <label for="partNumber">Part Number</label>
                              <input class="form-control form-control-sm" type="text"
                                formControlName="partNumber">
                            </div>
                            @if (lineInformation.get('serviceType').value == 'Parts') {
                              <div class="form-group col-md-3 col-sm-12"
                                >
                                <label for="quantity">Quantity</label>
                                <input class="form-control form-control-sm" type="number"
                                  formControlName="quantity">
                              </div>
                            }
                            @if (lineInformation.get('serviceType').value == 'Parts') {
                              <div class="form-group col-md-3 col-sm-12"
                                >
                                <label for="price">Price</label>
                                <input class="form-control form-control-sm" type="number"
                                  formControlName="price">
                              </div>
                            }
                            @if (lineInformation.get('serviceType').value == 'Labor') {
                              <div class="form-group col-md-3 col-sm-12"
                                >
                                <label for="rate">Rate</label>
                                <input class="form-control form-control-sm" type="number"
                                  formControlName="rate">
                              </div>
                            }
                            @if (lineInformation.get('serviceType').value == 'Labor') {
                              <div class="form-group col-md-3 col-sm-12"
                                >
                                <label for="hours">Hours</label>
                                <input class="form-control form-control-sm" type="number"
                                  formControlName="hours">
                              </div>
                            }
                            </div> <label for="lineTotal">Line Total</label>
                            ${{calculateLineTotal()}}
                            <div class="float-right d-flex justify-content-between">
                              <button type="button" class="btn btn-danger btn-sm" id="cancel"
                                (click)="resetLineInformation(i)">
                                Cancel
                              </button>
                              <button type="button" class="btn btn-primary btn-sm" id="save"
                                (click)="save(i)" [disabled]="this.lineInformation.pristine">
                                <span class="dripicons dripicons-cloud-upload"></span>
                                Save
                              </button>
                            </div>
                          </form>
                        </td>
                        <td class="lineInfoText-{{i}}">{{line.serviceType}}</td>
                        <td class="lineInfoText-{{i}}">{{line.description}}</td>
                        <td class="lineInfoText-{{i}}">{{line.partNumber}}</td>
                        <td class="lineInfoText-{{i}}">{{line.quantity}}</td>
                        <td class="lineInfoText-{{i}}">{{line.price}}</td>
                        <td class="lineInfoText-{{i}}">{{line.rate}}</td>
                        <td class="lineInfoText-{{i}}">{{line.hours}}</td>
                        <td class="lineInfoText-{{i}}">${{line.lineTotal}}</td>
                        @if (!lineInfoEdit) {
                          <td>
                            <span class="uil-pen text-dark"
                            (click)="setLineInformation(line, i)"></span>
                            <span class="uil-trash-alt text-danger" data-target="#deleteLineModal"
                            (click)="setLineNumber(line.id)" data-toggle="modal"></span>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Delete Modal -->
<div id="deleteLineModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteTicketLine' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deleteTicketLine()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'yes' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal"
          id="close-delete-line-modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Delete Modal -->
<div id="deleteHeaderModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="mySmallModalLabel">
  <div class="modal-dialog modal-sm modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
        <span class="dripicons-cross text-danger h1"></span>
        <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
        <span class="text-muted my-3 text-center">{{ words[language][ 'deleteTicket' ] }}</span>
        <button class="btn btn-danger mt-2" (click)="deleteTicketHeader()" [disabled]="loading">
          @if (loading) {
            <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
          }
          {{ words[language][ 'yes' ] }}
        </button>
        <button type="button" class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="close-delete-modal"
         >
          No
        </button>
      </div>
    </div>
  </div>
</div>